import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import analyticsManager from './application/analyticsManager';
import PageNotFound from './application/PageNotFound';
import ColumnAttributionRoute from './columns/ColumnAttributionRoute';
import DimensionAttributionRoute from './dimensions/DimensionAttributionRoute';
import CatalogSearchRoute from './search/CatalogSearchRoute';

let lastPage = document.referrer;

function trackPageview({ location }) {
  if (window.analytics) window.analytics.page();

  analyticsManager.page({
    sentAt: new Date(),
    referer: lastPage,
    title: document.title,
  });
  lastPage = location.pathname;
}

function ApplicationRouter() {
  const location = useLocation();

  React.useEffect(() => {
    trackPageview({ location });
  }, [location]);

  return (
    <Routes>
      <Route
        exact
        path="/"
        element={<CatalogSearchRoute />}
      />
      <Route
        exact
        path="/columns/:id/"
        element={<ColumnAttributionRoute />}
      />
      <Route
        exact
        path="/dimensions/:id/"
        element={<DimensionAttributionRoute />}
      />
      <Route
        path="*"
        element={<PageNotFound />}
      />
    </Routes>
  );
}

export default ApplicationRouter;
